<template>
    <div class="main-content">
       <AboutMe />
       <Services />
       <Skills />
       <Experiences />
       <Resume />
       <Contact />
       <a @click="goto('Impressum')">Impressum</a> <a @click="goto('Datenschutz')">Datenschutzerklärung</a>
    </div>
</template>

<script>
import AboutMe from './AboutMe.vue'
import Resume from './Resume.vue'
import Services from './Services.vue'
import Skills from './Skills.vue'
import Experiences from './Experiences.vue'
import Contact from './Contact.vue'

export default {
  name: 'MainContent',
  methods: {
    goto(contentTemplate) {
      this.$emit("changeComponent", contentTemplate);
    }
  },
  components: {
    AboutMe,
    Resume,
    Services,
    Skills,
    Experiences,
    Contact
  }
}
</script>

<style>
.main-content {
  padding-top: 2rem;
  color: #3c4172;
  font-family: 'Poppins', sans-serif;
}

.main-content .section-dark {
  background-color: #f0f3f5;
  padding: 60px 0px;
}

.main-content .section-dark.resume {
  padding-top: 100px;
}

@media (max-width: 599px) {
  .main-content .section-dark.resume {
    padding-top: 75px;
  }
}

.main-content .section-dark.resume .title {
  padding: 20px;
}

.main-content .section-dark.resume button {
  border: 2px solid #43485c;
  background: white;
  color: #43485c;
  height: 50px;
  width: 250px;
  font-size: 1rem;
  text-transform: uppercase;
}

.main-content .section-dark.resume .fa-download {
  color: #1f2c6c;
}

.main-content .section-dark.experiences {
  padding: 120px;
}

@media (max-width: 599px) {
  .main-content .section-dark.experiences {
    padding: 75px 20px;
  }
}

.main-content .section-dark.experiences .work-item {
  margin-bottom: 1rem;
  -webkit-transition: all .1s ease-in-out;
  transition: all .1s ease-in-out;
  border-radius: 5px;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 5px 20px rgba(14, 25, 80, 0.3);
}

.main-content .section-dark.experiences .work-item:hover {
  -webkit-transform: scale(1.055) translateY(-2px);
  transform: scale(1.055) translateY(-2px);
  -webkit-box-shadow: 0 2px 25px 0 rgba(30, 30, 30, 0.1);
  box-shadow: 0 2px 25px 0 rgba(30, 30, 30, 0.1);
}

.main-content .section-light {
  padding: 30px;
}

.main-content .section-light.about-me {
  padding-bottom: 100px;
}

.main-content .section-light.about-me .is-larger {
  font-size: 1.2rem;
}

@media (max-width: 599px) {
  .main-content .section-light.about-me .about-links {
    text-align: center;
  }
}

.main-content .section-light.about-me .right-image img {
  border-radius: 11px;
  margin: 20px;
  box-shadow: 0 5px 20px rgba(14, 25, 80, 0.3);
}

@media (max-width: 599px) {
  .main-content .section-light.about-me .right-image img {
    margin: auto;
  }
}

.main-content .section-light.skills {
  padding: 100px;
}

@media (max-width: 599px) {
  .main-content .section-light.skills {
    padding: 50px 20px 40px 20px;
    padding-bottom: 20px;
  }
}

.main-content .section-light.skills h1 {
  padding: 10px;
}

.main-content .section-light.contact {
  padding-top: 100px;
}

.main-content .section-light.contact button {
  width: 100%;
  background-color: #43485c;
  color: white;
  height: 50px;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
}

@media (max-width: 599px) {
  .main-content .section-light.contact {
    padding: 60px 20px;
  }
}

.main-content .section-color.services {
  padding: 50px;
  background-color: #4c567b; /* #43485c */
  color: white;
}

.main-content .section-color.services .title,
.main-content .section-color.services .subtitle {
  color: white;
}

.main-content .section-color.services i {
  font-size: 3rem;
  padding: 20px;
}


.main-content .section-title {
  color: #43485c;

  font-size: 1.8rem;
  letter-spacing: 2px;
  padding-bottom: 30px;
}

</style>
